<template>
  <v-snackbar
    v-model="showBanner"
    :timeout="-1"
    location="bottom"
    multi-line
    color="surface"
    class="cookie-consent-banner"
    content-class="cookie-consent-content"
  >
    <div class="d-flex flex-column flex-sm-row align-sm-center ga-4">
      <div class="flex-grow-1">
        <div class="text-body-2">
          We use cookies to analyze website traffic and improve your experience.
          See our
          <nuxt-link
            to="/about/privacy-policy"
            class="text-primary"
          >
            Privacy Policy
          </nuxt-link>
          for details.
        </div>
      </div>
      <div class="d-flex ga-2 flex-shrink-0">
        <v-btn
          variant="outlined"
          size="small"
          @click="rejectAll"
        >
          Reject All
        </v-btn>
        <v-btn
          variant="flat"
          color="primary"
          size="small"
          @click="acceptAll"
        >
          Accept All
        </v-btn>
      </div>
    </div>
  </v-snackbar>
</template>

<script setup lang="ts">
import { useCookieConsent } from '~/composables/useCookieConsent';

const { showBanner, acceptAll, rejectAll } = useCookieConsent();
</script>

<style lang="css">
.cookie-consent-banner .v-snackbar__wrapper {
  max-width: 800px;
  margin: 0 auto 16px;
}

.cookie-consent-content {
  width: 100%;
}
</style>
